import { Language } from '../translations'

export const salesTranslations: Record<string, Record<Language, string>> = {
  // Hansel component
  hanselTitle: { en: "Hansel", fi: "Hansel" },
  hanselDescription: { 
    en: "Upload PDF invoices to convert them into an XLSX file for Hansel reporting service", 
    fi: "Lataa PDF-laskut muuntaaksesi ne XLSX-tiedostoksi Hansel-raportointipalvelua varten" 
  },
  
  // File upload
  clickToUpload: { en: "Click to upload PDF files", fi: "Klikkaa ladataksesi PDF-tiedostoja" },
  dragAndDrop: { en: "or drag and drop your invoice PDFs here", fi: "tai vedä ja pudota laskusi PDF-tiedostot tähän" },
  selectedFiles: { en: "Selected Files", fi: "Valitut tiedostot" },
  
  // Toast notifications
  invalidFileType: { en: "Invalid file type", fi: "Virheellinen tiedostotyyppi" },
  onlyPdfAllowed: { en: "Only PDF files are allowed", fi: "Vain PDF-tiedostot ovat sallittuja" },
  noFilesSelected: { en: "No files selected", fi: "Ei tiedostoja valittu" },
  selectAtLeastOne: { en: "Please select at least one PDF file", fi: "Valitse vähintään yksi PDF-tiedosto" },
  
  // Processing results
  successTitle: { en: "Success", fi: "Onnistui" },
  successfullyProcessed: { en: "Successfully processed", fi: "Käsiteltiin onnistuneesti" },
  file: { en: "file", fi: "tiedosto" },
  files: { en: "files", fi: "tiedostoa" },
  
  partialSuccess: { en: "Partial success", fi: "Osittain onnistui" },
  processed: { en: "Processed", fi: "Käsitelty" },
  successfully: { en: "successfully", fi: "onnistuneesti" },
  failed: { en: "failed", fi: "epäonnistui" },
  failedFiles: { en: "Failed files", fi: "Epäonnistuneet tiedostot" },
  
  failedToProcessAll: { en: "Failed to process all files", fi: "Kaikkien tiedostojen käsittely epäonnistui" },
  failedToProcessPdf: { en: "Failed to process PDF files", fi: "PDF-tiedostojen käsittely epäonnistui" },
  unknownError: { en: "Unknown error occurred", fi: "Tuntematon virhe" },
  
  // Button states
  processing: { en: "Processing...", fi: "Käsitellään..." },
  processToXlsx: { en: "Process to XLSX", fi: "Käsittele XLSX:ksi" },
  
  // Contract Settings
  contractSettings: { en: "Contract Settings", fi: "Sopimusasetukset" },
  contractSettingsDescription: { 
    en: "Manage contracts and their associated product numbers", 
    fi: "Hallinnoi sopimuksia ja niihin liittyviä tuotenumeroita" 
  },
  addContract: { en: "Add Contract", fi: "Lisää sopimus" },
  addContractDescription: { 
    en: "Create a new contract. Contract number is required and must be unique.", 
    fi: "Luo uusi sopimus. Sopimusnumero on pakollinen ja sen on oltava yksilöllinen." 
  },
  contract: { en: "Contract", fi: "Sopimus" },
  contractNumber: { en: "Contract Number", fi: "Sopimusnumero" },
  contractName: { en: "Contract Name", fi: "Sopimuksen nimi" },
  enterContractNumber: { en: "Enter contract number", fi: "Syötä sopimusnumero" },
  enterContractName: { en: "Enter contract name", fi: "Syötä sopimuksen nimi" },
  contractNumberRequired: { en: "Contract number is required", fi: "Sopimusnumero on pakollinen" },
  contractNumberMustBeUnique: { en: "Contract number must be unique", fi: "Sopimusnumeron on oltava yksilöllinen" },
  noContracts: { en: "No contracts yet. Add your first contract to get started.", fi: "Ei sopimuksia. Lisää ensimmäinen sopimus aloittaaksesi." },
  selectContract: { en: "Select contract", fi: "Valitse sopimus" },
  
  // Contract CRUD
  contractCreated: { en: "Contract created successfully", fi: "Sopimus luotu onnistuneesti" },
  contractUpdated: { en: "Contract updated successfully", fi: "Sopimus päivitetty onnistuneesti" },
  contractDeleted: { en: "Contract deleted successfully", fi: "Sopimus poistettu onnistuneesti" },
  errorLoadingContracts: { en: "Error loading contracts", fi: "Virhe ladattaessa sopimuksia" },
  errorCreatingContract: { en: "Error creating contract", fi: "Virhe luotaessa sopimusta" },
  errorUpdatingContract: { en: "Error updating contract", fi: "Virhe päivitettäessä sopimusta" },
  errorDeletingContract: { en: "Error deleting contract", fi: "Virhe poistettaessa sopimusta" },
  confirmDeleteContractMessage: { 
    en: "Are you sure you want to delete this contract? This will also delete all associated product numbers. This action cannot be undone.", 
    fi: "Haluatko varmasti poistaa tämän sopimuksen? Tämä poistaa myös kaikki siihen liittyvät tuotenumerot. Toimintoa ei voi kumota." 
  },
  editContract: { en: "Edit Contract", fi: "Muokkaa sopimusta" },
  deleteContract: { en: "Delete Contract", fi: "Poista sopimus" },
  editContractDescription: { 
    en: "Update contract number and name.", 
    fi: "Päivitä sopimusnumero ja nimi."
  },
  
  // Product Numbers
  products: { en: "Product Numbers", fi: "Tuotenumerot" },
  addProduct: { en: "Add Product Number", fi: "Lisää tuotenumero" },
  productNumber: { en: "Product Number", fi: "Tuotenumero" },
  productDescription: { en: "Description", fi: "Kuvaus" },
  noProducts: { en: "No product numbers added yet", fi: "Ei tuotenumeroita" },
  productNumberRequired: { en: "Product number is required", fi: "Tuotenumero on pakollinen" },
  
  // Product CRUD
  productAdded: { en: "Product number added successfully", fi: "Tuotenumero lisätty onnistuneesti" },
  productUpdated: { en: "Product number updated successfully", fi: "Tuotenumero päivitetty onnistuneesti" },
  productDeleted: { en: "Product number deleted successfully", fi: "Tuotenumero poistettu onnistuneesti" },
  errorAddingProduct: { en: "Error adding product number", fi: "Virhe lisättäessä tuotenumeroa" },
  errorUpdatingProduct: { en: "Error updating product number", fi: "Virhe päivitettäessä tuotenumeroa" },
  errorDeletingProduct: { en: "Error deleting product number", fi: "Virhe poistettaessa tuotenumeroa" },
  confirmDeleteProduct: { 
    en: "Are you sure you want to delete this product number?", 
    fi: "Haluatko varmasti poistaa tämän tuotenumeron?" 
  },
  
  // Common actions
  cancel: { en: "Cancel", fi: "Peruuta" },
  add: { en: "Add", fi: "Lisää" },
  adding: { en: "Adding...", fi: "Lisätään..." },
  delete: { en: "Delete", fi: "Poista" },
  deleting: { en: "Deleting...", fi: "Poistetaan..." },
  confirmDelete: { en: "Confirm Delete", fi: "Vahvista poisto" },
};
